import React, { useCallback, useState, useEffect } from 'react';
// import {
//   SortableContainer,
//   SortableElement,
//   SortableHandle,
// } from 'react-sortable-hoc';
import './styles.scss';
import { Input } from 'antd';
// import arrayMove from 'array-move';

import {
  DndContext,
  useSensor,
  useSensors,
  PointerSensor,
  KeyboardSensor,
  closestCenter,
} from '@dnd-kit/core';
import {
  SortableContext,
  verticalListSortingStrategy,
  useSortable,
  arrayMove,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

function DragHandle(props) {
  return (
    <div className="drag-handle" {...props}>
      <span className="appkiticon icon-menu-outline" />
    </div>
  );
}

function SortableItem({ id, option, onTextChange }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const [value, setValue] = useState(option.label);

  useEffect(() => {
    setValue(option.label);
  }, [option.label]);

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  const onBlur = (e) => {
    const newValue = e.target.value.trim();
    if (newValue !== option.label) {
      onTextChange(newValue, option.value);
    }
  };

  return (
    <li
      className="list-item"
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
    >
      <DragHandle {...listeners} />
      <div className="input-warpper">
        <Input
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onBlur={onBlur}
          maxLength={40}
          autoComplete="off"
        />
      </div>
    </li>
  );
}

function SubModuleSorter({ options = [], onChange }) {
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: (event, { context }) => closestCenter(event, context),
    }),
  );

  const [items, setItems] = useState(options);

  useEffect(() => {
    setItems(options);
  }, [options]);

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (active.id !== over.id) {
      const oldIndex = items.findIndex((i) => i.value === active.id);
      const newIndex = items.findIndex((i) => i.value === over.id);
      const newItems = arrayMove(items, oldIndex, newIndex);
      setItems(newItems);
      onChange(newItems);
    }
  };

  const handleTextChange = useCallback(
    (text, value) => {
      setItems((currentItems) => {
        const newItems = currentItems.map((item) => {
          if (item.value === value) {
            return { ...item, label: text };
          }
          return item;
        });
        onChange(newItems);
        return newItems;
      });
    },
    [onChange],
  );

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={handleDragEnd}
    >
      <SortableContext
        items={items.map((item) => item.value)}
        strategy={verticalListSortingStrategy}
      >
        <ul className="submodule-sorter">
          {items.map((option) => (
            <SortableItem
              key={option.value}
              id={option.value}
              option={option}
              onTextChange={handleTextChange}
            />
          ))}
        </ul>
      </SortableContext>
    </DndContext>
  );
}

export default SubModuleSorter;
